/* منع شريط العدّاد العلوي من تغطية الهيدر + إزالة الفراغ فوق التصميم */
(function(){
  function trim(){
    var mc=document.querySelector('.main-content');
    if(mc){ mc.style.paddingTop='0'; mc.style.paddingBottom='0'; }
  }
  function barH(){
    var els=document.body.querySelectorAll('div,section,aside,header');
    var best=0;
    for(var i=0;i<els.length;i++){
      var el=els[i];
      if(el.id==='zk'||el.id==='sb'||(el.closest&&el.closest('#zk')))continue;
      var st=getComputedStyle(el);
      if(st.position!=='fixed'||st.display==='none'||st.visibility==='hidden')continue;
      var r=el.getBoundingClientRect();
      if(r.top>4||r.height<24||r.height>320||r.width<window.innerWidth*0.75)continue;
      if(r.height>best)best=r.height;
    }
    return Math.ceil(best);
  }
  function fix(){
    trim();
    var h=barH();
    var cur=parseInt(document.body.style.paddingTop||'0',10)||0;
    if(!h){ if(cur)document.body.style.paddingTop=''; return; }
    if(Math.abs(cur-h)>2) document.body.style.paddingTop=h+'px';
  }
  fix();
  setTimeout(fix,500); setTimeout(fix,1400); setTimeout(fix,3000); setTimeout(fix,5500);
  window.addEventListener('resize',fix);
  window.addEventListener('load',fix);
})();
